//在index.js中引入axios
import axios from 'axios'
import cookie from 'react-cookies'
// import { useNavigate } from 'react-router-dom';
//引入qs模块，用来序列化post类型的数据
// import QS from 'qs';
//antd的message提示组件，大家可根据自己的ui组件更改。
// import { message } from 'antd'

//从运行时配置读取API基础URL（优先），其次从环境变量读取，最后使用默认值
//打包后可以直接修改 public/config.js 文件来切换环境，无需重新打包
export const basicUrl = (typeof window !== 'undefined' && window.APP_CONFIG?.apiBaseUrl) 
  || process.env.REACT_APP_API_BASE_URL 
  || 'http://139.196.139.138/api/'

//设置axios基础路径
const service = axios.create({
  baseURL: basicUrl
})
// 请求拦截器
service.interceptors.request.use(config => {
  // 每次发送请求之前本地存储中是否存在token，也可以通过Redux这里只演示通过本地拿到token
  // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
  // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
  //设置请求头

  const token = cookie.load('userToken') || cookie.load('userToken');
  config.headers.AuthorizationToken = token;
  config.headers.AuthorizationUserId = cookie.load('userId'); // window.sessionStorage.getItem("userId");

  return config
}, error => {
  // 请求错误处理q
  console.error('请求发送失败:', error);
  return Promise.reject(error);
})

// 响应拦截器
service.interceptors.response.use(response => {
  // const urlRoute = useNavigate();
  //根据返回不同的状态码做不同的事情
  // 这里一定要和后台开发人员协商好统一的错误状态码

  if (response.data) {
    switch (response.data.status) {
      case 200:
        return response.data;
      case 401:
        //未登录处理方法
        break;
      case 403:
        //token过期处理方法
        break;
      case 505:
        window.sessionStorage.removeItem("userToken");
        window.sessionStorage.removeItem("userId");
        cookie.remove('userToken')
        cookie.remove('userId')
        window.location.href = '/timeout';
        return null;
      case 500:
        console.log("接口报错")
        //token过期处理方法
        return response.data;
      case 503:
        window.sessionStorage.removeItem("userToken");
        window.sessionStorage.removeItem("userId");
        cookie.remove('userToken')
        cookie.remove('userId')
        window.location.href = '/timeout';
        //token过期处理方法
        break;
      default:
        return response.data;
      //message.error(response.data.msg)
    }
  } else {
    return response;
  }
}, error => {
  // 全局错误处理
  console.error('请求响应错误:', error);

  // 处理网络错误
  if (error.message === 'Network Error') {
    console.warn('网络连接失败，请检查网络设置');
    // 可以在这里添加用户友好的提示，比如使用 antd 的 message
    // message.error('网络连接失败，请检查网络设置');
    
    // 返回一个默认的响应，避免页面崩溃
    return Promise.resolve({
      success: false,
      status: 'network_error',
      message: '网络连接失败',
      data: null
    });
  }

  // 处理超时错误
  if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
    console.warn('请求超时，请稍后重试');
    return Promise.resolve({
      success: false,
      status: 'timeout',
      message: '请求超时',
      data: null
    });
  }

  // 处理 HTTP 状态码错误
  if (error.response) {
    const status = error.response.status;
    switch (status) {
      case 400:
        console.error('请求参数错误');
        break;
      case 401:
        console.error('未授权，请重新登录');
        // 可以跳转到登录页
        // window.location.href = '/login';
        break;
      case 403:
        console.error('拒绝访问');
        break;
      case 404:
        console.error('请求的资源不存在');
        break;
      case 500:
        console.error('服务器内部错误');
        break;
      case 502:
        console.error('网关错误');
        break;
      case 503:
        console.error('服务不可用');
        break;
      case 504:
        console.error('网关超时');
        break;
      default:
        console.error(`请求失败: ${status}`);
    }

    // 返回错误响应，避免页面崩溃
    return Promise.resolve({
      success: false,
      status: error.response.status,
      message: error.response.data?.message || '请求失败',
      data: null
    });
  }

  // 其他未知错误1
  console.error('未知错误:', error.message);
  return Promise.resolve({
    success: false,
    status: 'unknown_error',
    message: '请求失败，请稍后重试',
    data: null
  });
})

//最后把封装好的axios导出
export default service
